import { TransactionFilter } from '../models/transactions';
import { LocationFilter } from '../models/locations';


// Filters
export function addTransactionFilter(qs: any, filter: TransactionFilter) {
  if (filter) {
    if (filter.q) {
      qs.q = filter.q;
    }

    if (filter.locationId) {
      qs.locationId = filter.locationId;
    }
  }

  return qs;
}

export function addLocationFilter(qs: any, filter: LocationFilter) {
  if (filter) {
    if (filter.q) {
      qs.q = filter.q;
    }
  }

  return qs;
}
